module.exports = __webpack_public_path__ + "distribution/img/is-guanzhu.869e5bec.png";